/*
 * Deep link
 */

// const appUser = 'application_user'
// const appRT = 'storekeepers'

const deepLink = function(params) {
  return {
    data: function() {
      return {
        baseRappi: 'gbrappi://com.grability.rappi?',
        baseRappiUniversal: 'https://www.rappi.com/?',
        dismissIOS: 'dismiss_view=true&',
        queryParams: null,
        appUser: 'application_user',
        appRT: 'storekeepers',
        homeDeeplinkRT: 'https://cy3xs.app.link/zonesmap',
      }
    },
    computed: {
      iOSQuery() {
        const qs = this.queryParams.includes('goto=home')
          ? this.queryParams.replace('goto=home', '')
          : this.queryParams
        return qs.replace(/ /g, '%20')
      },
    },
    methods: {
      callDeepLink: function(queryParams, userType = this.appUser) {
        this.queryParams = queryParams

        if (userType === this.appRT)
          return window.open(this.homeDeeplinkRT, '_top')

        switch (this.getMobileOperatingSystem()) {
          case 'iOS':
            window.open(
              `${this.baseRappi}${this.dismissIOS}${this.iOSQuery}`,
              '_top'
            )
            break
          case 'Android':
            window.open(`${this.baseRappi}${queryParams}`, '_top')
            break
          default:
            window.open(`${this.baseRappi}${queryParams}`, '_top')
            break
        }
      },
      thirdPartyDeepLink: function(deeplink) {
        window.open(deeplink, '_top')
      },
      getMobileOperatingSystem: function() {
        const userAgent =
          navigator.userAgent.toLowerCase() ||
          navigator.vendor.toLowerCase() ||
          window.opera.toLowerCase()

        if (
          userAgent.match(/ipad/i) ||
          userAgent.match(/iphone/i) ||
          userAgent.match(/ipod/i)
        ) {
          return 'iOS'
        } else if (userAgent.match(/android/i)) {
          return 'Android'
        } else {
          return 'unknown'
        }
      },
      callPhone: function(phoneNumber) {
        const basePhone = 'tel:'
        window.open(`${basePhone}${phoneNumber}`, '_top')
      },
      goToArticleBuilder: function(articleId) {
        this.$router.push({
          name: 'zendesk-articles',
          query: this.$route.query,
          params: {
            articleId: articleId,
          },
        })
      },
      callGenericDeeplink: function(genericDeeplink) {
        this.queryParams = genericDeeplink
        const userOS = this.getMobileOperatingSystem()

        if (userOS === 'iOS') {
          const deeplinkToOpen = `
            ${genericDeeplink}&${this.dismissIOS.slice(0, 1)}`
            window.open(deeplinkToOpen, '_top')
        } else {
          const deeplinkToOpen = `${this.queryParams}`
          window.open(deeplinkToOpen, '_top')
        }
      },
    },
  }
}

export default deepLink
